const act = {
  title: 'Australian Capital Territory (ACT)',
  links: [
    {
      anchorText: 'Canberra',
      searchAreaId: '30936',
      path: 'canberra-act',
    },
    {
      anchorText: 'Tuggeranong',
      searchAreaId: '30934',
      path: 'tuggeranong-act',
    },
    {
      anchorText: 'Gungahlin',
      searchAreaId: '19141',
      path: 'gungahlin-act',
    },
    {
      anchorText: 'Woden Valley',
      searchAreaId: '30937',
      path: 'woden-valley-act',
    },
    {
      anchorText: 'Kingston',
      searchAreaId: '17561',
      path: 'kingston-act',
    },
    {
      anchorText: 'Wanniassa',
      searchAreaId: '19124',
      path: 'wanniassa-act',
    },
    {
      anchorText: 'Gordon',
      searchAreaId: '19138',
      path: 'gordon-act',
    },
    {
      anchorText: 'Aranda',
      searchAreaId: '17607',
      path: 'aranda-act',
    },
    {
      anchorText: 'Belconnen',
      searchAreaId: '17628',
      path: 'belconnen-act-2617',
    },
    {
      anchorText: 'Holt',
      searchAreaId: '17621',
      path: 'holt-act',
    },
    {
      anchorText: 'Amaroo',
      searchAreaId: '19150',
      path: 'amaroo-act',
    },
    {
      anchorText: 'Evatt',
      searchAreaId: '17631',
      path: 'evatt-act',
    },
    {
      anchorText: 'Florey',
      searchAreaId: '17617',
      path: 'florey-act',
    },
    {
      anchorText: 'Griffith',
      searchAreaId: '17557',
      path: 'griffith-act',
    },
    {
      anchorText: 'Weston',
      searchAreaId: '17601',
      path: 'weston-act',
    },
    {
      anchorText: 'Spence',
      searchAreaId: '17626',
      path: 'spence-act',
    },
    {
      anchorText: 'Civic',
      searchAreaId: '17548',
      path: 'civic-act',
    },
    {
      anchorText: 'Torrens',
      searchAreaId: '17577',
      path: 'torrens-act',
    },
    {
      anchorText: 'Hackett',
      searchAreaId: '17552',
      path: 'hackett-act',
    },
    {
      anchorText: 'Fraser',
      searchAreaId: '17619',
      path: 'fraser-act',
    },
    {
      anchorText: 'Chifley',
      searchAreaId: '17566',
      path: 'chifley-act',
    },
    {
      anchorText: 'Macgregor',
      searchAreaId: '17624',
      path: 'macgregor-act',
    },
    {
      anchorText: 'Mawson',
      searchAreaId: '17575',
      path: 'mawson-act',
    },
    {
      anchorText: 'Watson',
      searchAreaId: '17555',
      path: 'watson-act',
    },
    {
      anchorText: 'Banks',
      searchAreaId: '19136',
      path: 'banks-act',
    },
    {
      anchorText: 'Chisholm',
      searchAreaId: '19131',
      path: 'chisholm-act',
    },
    {
      anchorText: 'Chapman',
      searchAreaId: '17588',
      path: 'chapman-act',
    },
    {
      anchorText: 'Kaleen',
      searchAreaId: '17633',
      path: 'kaleen-act',
    },
    {
      anchorText: 'Melba',
      searchAreaId: '17625',
      path: 'melba-act',
    },
    {
      anchorText: 'Kambah',
      searchAreaId: '19120',
      path: 'kambah-act',
    },
    {
      anchorText: 'Majura',
      searchAreaId: '30933',
      path: 'majura-act',
    },
    {
      anchorText: 'Fisher',
      searchAreaId: '17591',
      path: 'fisher-act',
    },
    {
      anchorText: 'Hall',
      searchAreaId: '17637',
      path: 'hall-act',
    },
    {
      anchorText: 'Casey',
      searchAreaId: '19142',
      path: 'casey-act',
    },
    {
      anchorText: 'Latham',
      searchAreaId: '17623',
      path: 'latham-act',
    },
    {
      anchorText: 'Hume',
      searchAreaId: '17650',
      path: 'hume-act',
    },
    {
      anchorText: 'Downer',
      searchAreaId: '17551',
      path: 'downer-act',
    },
    {
      anchorText: 'Acton',
      searchAreaId: '17545',
      path: 'acton-act',
    },
    {
      anchorText: 'Page',
      searchAreaId: '17612',
      path: 'page-act',
    },
    {
      anchorText: 'Isabella Plains',
      searchAreaId: '19133',
      path: 'isabella-plains-act',
    },
    {
      anchorText: 'Bonython',
      searchAreaId: '19129',
      path: 'bonython-act',
    },
    {
      anchorText: 'Pearce',
      searchAreaId: '17576',
      path: 'pearce-act',
    },
    {
      anchorText: 'Narrabundah',
      searchAreaId: '17562',
      path: 'narrabundah-act',
    },
    {
      anchorText: 'Weetangera',
      searchAreaId: '17614',
      path: 'weetangera-act',
    },
    {
      anchorText: 'Dunlop',
      searchAreaId: '17616',
      path: 'dunlop-act',
    },
    {
      anchorText: 'Lyons',
      searchAreaId: '17567',
      path: 'lyons-act',
    },
    {
      anchorText: 'Conder',
      searchAreaId: '19137',
      path: 'conder-act',
    },
    {
      anchorText: 'Fyshwick',
      searchAreaId: '17580',
      path: 'fyshwick-act',
    },
    {
      anchorText: 'Mitchell',
      searchAreaId: '19140',
      path: 'mitchell-act',
    },
    {
      anchorText: 'Beard',
      searchAreaId: '17641',
      path: 'beard-act',
    },
    {
      anchorText: 'Deakin',
      searchAreaId: '17535',
      path: 'deakin-act',
    },
    {
      anchorText: 'Wright',
      searchAreaId: '28407',
      path: 'wright-act',
    },
    {
      anchorText: 'Harrison',
      searchAreaId: '19153',
      path: 'harrison-act',
    },
    {
      anchorText: 'Pialligo',
      searchAreaId: '17582',
      path: 'pialligo-act',
    },
    {
      anchorText: 'Nicholls',
      searchAreaId: '19147',
      path: 'nicholls-act',
    },
    {
      anchorText: 'Rivett',
      searchAreaId: '17595',
      path: 'rivett-act',
    },
    {
      anchorText: 'Flynn',
      searchAreaId: '17618',
      path: 'flynn-act',
    },
    {
      anchorText: 'Braddon',
      searchAreaId: '17603',
      path: 'braddon-act',
    },
    {
      anchorText: 'Lyneham',
      searchAreaId: '17553',
      path: 'lyneham-act',
    },
    {
      anchorText: 'Denman Prospect',
      searchAreaId: '28792',
      path: 'denman-prospect-act',
    },
    {
      anchorText: 'Canberra CBD',
      searchAreaId: '30941',
      path: 'canberra-cbd-act',
    },
    {
      anchorText: 'Bruce',
      searchAreaId: '17630',
      path: 'bruce-act',
    },
    {
      anchorText: 'Turner',
      searchAreaId: '17606',
      path: 'turner-act',
    },
    {
      anchorText: 'Palmerston',
      searchAreaId: '19148',
      path: 'palmerston-act',
    },
    {
      anchorText: 'Parkes',
      searchAreaId: '17540',
      path: 'parkes-act',
    },
    {
      anchorText: 'Dickson',
      searchAreaId: '17550',
      path: 'dickson-act',
    },
    {
      anchorText: 'Duffy',
      searchAreaId: '17590',
      path: 'duffy-act',
    },
    {
      anchorText: 'Ngunnawal',
      searchAreaId: '19146',
      path: 'ngunnawal-act',
    },
    {
      anchorText: 'Bonner',
      searchAreaId: '19151',
      path: 'bonner-act',
    },
    {
      anchorText: 'Scullin',
      searchAreaId: '17613',
      path: 'scullin-act',
    },
    {
      anchorText: 'Calwell',
      searchAreaId: '19130',
      path: 'calwell-act',
    },
    {
      anchorText: 'Greenway',
      searchAreaId: '19117',
      path: 'greenway-act',
    },
    {
      anchorText: 'Waramanga',
      searchAreaId: '17600',
      path: 'waramanga-act',
    },
    {
      anchorText: 'Ainslie',
      searchAreaId: '17549',
      path: 'ainslie-act',
    },
    {
      anchorText: 'Symonston',
      searchAreaId: '17583',
      path: 'symonston-act',
    },
    {
      anchorText: 'Fadden',
      searchAreaId: '19125',
      path: 'fadden-act',
    },
    {
      anchorText: 'Franklin',
      searchAreaId: '19143',
      path: 'franklin-act',
    },
    {
      anchorText: 'Isaacs',
      searchAreaId: '17574',
      path: 'isaacs-act',
    },
    {
      anchorText: 'Farrer',
      searchAreaId: '17573',
      path: 'farrer-act',
    },
    {
      anchorText: 'Hawker',
      searchAreaId: '17609',
      path: 'hawker-act',
    },
    {
      anchorText: 'Macarthur',
      searchAreaId: '19127',
      path: 'macarthur-act',
    },
    {
      anchorText: 'Crace',
      searchAreaId: '19139',
      path: 'crace-act',
    },
    {
      anchorText: 'Red Hill',
      searchAreaId: '17559',
      path: 'red-hill-act',
    },
    {
      anchorText: 'McKellar',
      searchAreaId: '17635',
      path: 'mckellar-act',
    },
    {
      anchorText: 'Russell',
      searchAreaId: '17542',
      path: 'russell-act',
    },
    {
      anchorText: 'Oxley',
      searchAreaId: '19123',
      path: 'oxley-act',
    },
    {
      anchorText: 'Uriarra Village',
      searchAreaId: '28789',
      path: 'uriarra-village-act',
    },
    {
      anchorText: 'Gowrie',
      searchAreaId: '19126',
      path: 'gowrie-act',
    },
    {
      anchorText: 'Theodore',
      searchAreaId: '19135',
      path: 'theodore-act',
    },
    {
      anchorText: 'Capital Hill',
      searchAreaId: '17534',
      path: 'capital-hill-act',
    },
    {
      anchorText: 'Forde',
      searchAreaId: '19152',
      path: 'forde-act',
    },
    {
      anchorText: 'Garran',
      searchAreaId: '17564',
      path: 'garran-act',
    },
    {
      anchorText: 'Macquarie',
      searchAreaId: '17611',
      path: 'macquarie-act',
    },
    {
      anchorText: 'Forrest',
      searchAreaId: '17556',
      path: 'forrest-act',
    },
    {
      anchorText: 'Phillip',
      searchAreaId: '17569',
      path: 'phillip-act',
    },
    {
      anchorText: 'Tharwa',
      searchAreaId: '17661',
      path: 'tharwa-act',
    },
    {
      anchorText: 'Yarralumla',
      searchAreaId: '17544',
      path: 'yarralumla-act',
    },
    {
      anchorText: 'Hughes',
      searchAreaId: '17565',
      path: 'hughes-act',
    },
    {
      anchorText: 'Monash',
      searchAreaId: '19128',
      path: 'monash-act',
    },
    {
      anchorText: 'Barton',
      searchAreaId: '17532',
      path: 'barton-act-2600',
    },
  ],
};

export { act };
